export default "__VITE_ASSET__CIdo3bRc__"